var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("/* Google Fonts */\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Lexend:wght@100..900&display=swap\");\n\n/* Converted custom styles */\n.btn-primary {\n    padding: 0.5rem 0.75rem;\n    /* px-3 py-2 */\n    background-color: #3c65f5;\n    color: white;\n    border-radius: 0.5rem;\n    /* rounded-lg */\n    font-size: 0.875rem;\n    /* text-sm */\n    font-weight: 600;\n    /* font-semibold */\n    transition: background-color 0.2s ease-in-out;\n}\n\n.btn-primary:hover {\n    background-color: #3355d1;\n}\n\n.btn-primary:disabled {\n    cursor: not-allowed;\n    background-color: #f6f6f6;\n    color: #b4b4b4;\n    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n}\n\n.btn-outline {\n    padding: 0.5rem 0.75rem;\n    border: 1px solid #d1d5db;\n    border-radius: 0.5rem;\n    font-size: 0.875rem;\n    font-weight: 600;\n    color: #4c4f59;\n    background-color: white;\n    transition: background-color 0.2s ease-in-out;\n}\n\n.btn-outline:hover {\n    background-color: #f3f4f6;\n    /* hover:bg-gray-100 */\n}\n\nbutton:focus {\n    outline: none;\n    box-shadow: none;\n}\n\n.link {\n    display: inline-flex;\n    align-items: center;\n    justify-content: flex-start;\n    font-size: 0.75rem;\n    font-weight: 500;\n    line-height: 1.25;\n    color: #3b82f6;\n    text-decoration: none;\n    transition: all 0.3s;\n}\n\n.link:hover {\n    color: #3532eacc;\n    text-decoration: underline;\n}\n\ninput {\n    border: 1px solid red;\n    outline: none;\n    box-shadow: none;\n}\n\n.fade-slide-enter-active,\n.fade-slide-leave-active {\n    transition: opacity 0.4s ease, transform 0.4s ease;\n}\n\n.fade-slide-enter-from,\n.fade-slide-leave-to {\n    opacity: 0;\n    transform: translateY(10px);\n}\n\n.fade-slide-leave-from,\n.fade-slide-enter-to {\n    opacity: 1;\n    transform: translateY(0);\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require("babel-runtime/core-js/object/entries");

var _entries2 = _interopRequireDefault(_entries);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _DeviceDataCollection = require("../../../iframev2/DeviceDataCollection.vue");

var _DeviceDataCollection2 = _interopRequireDefault(_DeviceDataCollection);

var _ThreeDs = require("./ThreeDs.vue");

var _ThreeDs2 = _interopRequireDefault(_ThreeDs);

var _dCard = require("./2dCard.vue");

var _dCard2 = _interopRequireDefault(_dCard);

var _CardErrors = require("./CardErrors.vue");

var _CardErrors2 = _interopRequireDefault(_CardErrors);

var _VerifyTransaction = require("./VerifyTransaction.vue");

var _VerifyTransaction2 = _interopRequireDefault(_VerifyTransaction);

var _SavedCardProfiles = require("./SavedCardProfiles.vue");

var _SavedCardProfiles2 = _interopRequireDefault(_SavedCardProfiles);

var _MasterCard = require("./mastercard/MasterCard.vue");

var _MasterCard2 = _interopRequireDefault(_MasterCard);

var _eventBus = require("../eventBus.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { VerifyTransactions: _VerifyTransaction2.default, CardinalCollection: _DeviceDataCollection2.default, ThreeDs: _ThreeDs2.default, TwoDCard: _dCard2.default, CardErrors: _CardErrors2.default, SavedCardProfiles: _SavedCardProfiles2.default, MasterCard: _MasterCard2.default },
    props: {
        gateway: {
            type: Object,
            required: true
        },
        amount_due: {
            type: Number,
            required: true
        },
        currency: {
            type: String,
            required: true
        },
        invoice_no: {
            type: String,
            required: true
        },
        base_url: {
            type: String,
            default: null
        },
        callback_url: {
            type: String,
            default: null
        },
        invoice: {
            type: Object,
            default: {}
        },
        twoDcard: {
            type: Object,
            required: true
        },
        masterCardGateway: {
            type: Object,
            required: true
        },
        masterCardTwoDcard: {
            type: Object,
            required: true
        },
        wallet_token: {
            type: String,
            required: true,
            default: ""
        },
        route_master_card_to_mpgs: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            step: null,
            amount: "0.00",
            loading: false,
            initPaymentResponse: null,
            showSuccessAlert: false,
            showErrorAlert: false,
            formParams: null,
            card_auth_type: null,

            decision: null,
            card_profile_id: null,

            deviceDataCollectionUrl: null,
            accessToken: null,
            origin: null,
            referenceID: null,
            trackingCode: null,

            stepupURL: null,
            pareqToken: null,
            trx_details: {},
            showCardErrors: false,
            cardErrors: [],
            savedCards: [],
            selectedCard: {},
            pendingVerification: false,
            cardType: "visa",
            cardNetworkJourney: "visa_journey" };
    },
    mounted: function mounted() {
        console.log("this is the amount", this.amount_due);
        console.log("this is the amount to charge", this.amountToCharge);
        this.checkPendingVerifications();
        _eventBus.eventBus.$emit("gateway-fees-updated", this.activeGateway.configs.card_charges);
    },

    methods: {
        checkPendingVerifications: async function checkPendingVerifications() {
            var params = { ref: this.invoice_no };
            var response = await Vue.axios.post(this.base_url + this.activeGateway.configs.cs_check_verifications_url, params, this.getAuthHeaders());

            if (response.data.message === "Found") {
                this.pendingVerification = true;
                this.card_auth_type = "two_d";
                this.card_profile_id = response.data.card_profile_id;
            } else {
                this.getAndCheckSavedCards();
            }
        },
        handleCancel: function handleCancel() {
            location.reload();
        },
        handleRevokePendingVerification: function handleRevokePendingVerification() {
            this.pendingVerification = false;
            this.handleTryDifferentCard();
        },
        getAuthHeaders: function getAuthHeaders() {
            return {
                headers: {
                    Authorization: "Bearer " + this.wallet_token,
                    "Content-Type": "application/json"
                }
            };
        },
        handleAddError: function handleAddError(error) {
            this.showCardErrors = true;
            this.cardErrors = [];
            this.cardErrors.push(error);
            if (this.cardErrors.includes("error while submitting form")) {
                this.step = 1;
            } else {
                this.step = 0;
            }
        },
        handleAddPaymentMethod: function handleAddPaymentMethod() {
            this.step = 1;
        },
        doHandleCardSelection: function doHandleCardSelection(details) {
            (0, _assign2.default)(this.selectedCard, details);
            this.step = 1;
        },
        handleRemoveCard: async function handleRemoveCard(id) {
            var existing = localStorage.getItem('profiles');
            if (existing) {
                try {
                    var parsed = JSON.parse(existing);

                    var index = parsed.uuids.indexOf(id);
                    if (index !== -1) {
                        parsed.uuids.splice(index, 1);
                    }

                    localStorage.setItem('profiles', (0, _stringify2.default)(parsed));
                    this.getAndCheckSavedCards();
                } catch (e) {}
            }
            var removeCardUrl = this.base_url + this.activeGateway.configs.cs_remove_card_url;
            try {
                var response = await Vue.axios.post(removeCardUrl, { card_profile: id }, this.getAuthHeaders());
            } catch (error) {}
        },
        handleFormParams: async function handleFormParams(data) {
            var info = this.getBrowserInfo();
            var card_brand = this.getCardBrand(data.cardNumber);
            var card_type = this.getCardType(card_brand);

            var params = {
                card_number: data.cardNumber,
                expiry_date: data.expiryDate,
                cvv: data.cvv,
                first_name: data.firstName,
                last_name: data.otherNames,
                email: data.email,
                city: data.city,
                state: data.state,
                latitude: data.latitude.toString(),
                longitude: data.longitude.toString(),
                ip_address: data.ipAddress,
                device_fingerprint: data.fingerPrint,
                gateway: this.activeGateway,
                amount: this.amountToCharge,
                currency: this.currency,
                ref: this.invoice_no,
                user_agent: info.userAgent,
                platform: info.platform,
                browser: info.browser,
                card_type: card_type,
                card_brand: card_brand,
                msisdn: data.phoneNumber,
                country: data.country,
                address: data.billing_address,
                postal_code: data.postalCode,
                administrative_area: data.administrative_area,
                locality: data.locality,
                tracking_no: this.invoice_no + new Date().toISOString().replace(/[-:T.Z]/g, '').slice(0, 15),
                save_card_profile: data.isSaved,
                timezone: data.transactionTimezone

            };
            var trimmedParams = Object.fromEntries((0, _entries2.default)(params).map(function (_ref) {
                var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
                    key = _ref2[0],
                    value = _ref2[1];

                if (typeof value === 'string') {
                    return [key, value.trim()];
                }
                return [key, value];
            }));

            this.formParams = trimmedParams;

            var init_api_url = this.base_url + this.activeGateway.configs.cs_init_url;
            this.step = 2;
            try {
                var response = await Vue.axios.post(init_api_url, this.formParams, this.getAuthHeaders());

                this.decision = response.data.decision;
                this.card_profile_id = response.data.card_profile_id;

                if (this.decision == 'decline') {
                    this.showCardErrors = true;
                    this.step = 0;
                    this.cardErrors = [];
                    this.cardErrors.push("Payment Could Not Be Processed");
                } else {
                    var localStorageData = { cardProfileID: response.data.card_profile_id, deviceFingerPrint: this.formParams.device_fingerprint, saveCardProfile: this.formParams.save_card_profile };
                    this.saveInLocalStorage(localStorageData);

                    if (this.getCardBrand(this.formParams.card_number) === "mastercard" && this.route_master_card_to_mpgs) {
                        this.cardNetworkJourney = "mastercard_journey";
                        this.step = 0;
                        this.formParams.gateway = this.activeGateway;
                    } else {
                        await this.handleSetup(this.card_profile_id);
                    }
                }
            } catch (error) {

                this.showCardErrors = true;
                this.cardErrors = [];
                this.cardErrors.push("error while submitting form");

                if (this.cardErrors.includes("error while submitting form")) {
                    this.step = 1;
                } else {
                    this.step = 0;
                }
            } finally {
                this.loading = false;
            }
        },
        handleSetup: async function handleSetup(card_profile_id) {
            var setup_api_url = this.base_url + this.activeGateway.configs.cs_setup_url;

            this.formParams.card_profile_id = card_profile_id;
            try {
                var response = await Vue.axios.post(setup_api_url, this.formParams, this.getAuthHeaders());

                if (response.data.status == "INCOMPLETED") {
                    this.step = 0;
                    this.card_auth_type = "two_d";

                    this.handleStepdown();
                } else {
                    this.referenceID = response.data.referenceId;
                    this.origin = response.data.origin;
                    this.accessToken = response.data.accessToken;
                    this.deviceDataCollectionUrl = response.data.deviceDataCollectionUrl;
                    this.trackingCode = response.data.tracking_no;
                    this.step = "DeviceDataCollection";
                }
            } catch (error) {
                this.step = 0;
                this.card_auth_type = "two_d";
                this.handleStepdown();
            } finally {
                this.loading = false;
            }
        },
        handleEnrollment: async function handleEnrollment(data) {

            this.formParams.tracking_code = this.trackingCode;
            this.formParams.reference_id = this.referenceID;
            this.formParams.country_code = this.formParams.country;

            var enrollment_api_url = this.base_url + this.activeGateway.configs.cs_enrollment_url;

            try {
                var response = await Vue.axios.post(enrollment_api_url, this.formParams, this.getAuthHeaders());

                if (response.data.status == "INCOMPLETED") {
                    this.step = 0;
                    this.card_auth_type = "two_d";
                    this.handleStepdown();
                } else {

                    this.stepupURL = response.data.stepup_url;
                    this.pareqToken = response.data.req_token;
                    var raw_trx_details = {
                        card: {
                            ref: this.formParams.ref,
                            card_no: this.formParams.card_number,
                            month: this.formParams.expiry_date ? this.formParams.expiry_date.split('/')[0] : '',
                            year: this.formParams.expiry_date ? this.formParams.expiry_date.split('/')[1] : '',
                            amount: this.formParams.amount,
                            currency: this.formParams.currency,
                            first_name: this.formParams.first_name,
                            last_name: this.formParams.last_name,
                            address: this.formParams.address,
                            locality: this.formParams.locality,
                            postal_code: this.formParams.postal_code,
                            administrative_area: this.formParams.administrative_area,
                            country_code: this.formParams.country,
                            email: this.formParams.email,
                            phone_number: this.formParams.msisdn,
                            expiry_year: this.formParams.expiry_date ? this.formParams.expiry_date.split('/')[1] : '',
                            expiry_month: this.formParams.expiry_date ? this.formParams.expiry_date.split('/')[0] : '',
                            CVV: this.formParams.cvv,
                            msisdn: this.formParams.msisdn,
                            type: this.formParams.card_type
                        },
                        payment: {
                            invoice_no: this.formParams.ref,
                            currency: this.formParams.currency,
                            gateway_id: this.activeGateway.id,
                            amount: this.formParams.amount,
                            tracking_no: this.trackingCode,
                            callback_url: this.callback_url
                        }
                    };
                    this.trx_details = (0, _stringify2.default)(raw_trx_details);
                    this.step = 0;
                    this.card_auth_type = "three_d";
                }
            } catch (error) {
                this.step = 0;
                this.card_auth_type = "two_d";
                this.handleStepdown();
            } finally {
                this.loading = false;
            }
        },
        handleTryAnotherWay: function handleTryAnotherWay() {
            this.handleStepdown();
        },
        handleStepup: function handleStepup(data) {},
        handleStepdown: async function handleStepdown() {

            var update_url = this.base_url + this.activeGateway.configs.cs_update_metadata_url;
            var update_params = { card_profile: this.card_profile_id, step_down: true };
            await Vue.axios.post(update_url, update_params, this.getAuthHeaders());
            this.step = 0;
            this.card_auth_type = "two_d";
        },
        routeMasterCardToCyberSource: async function routeMasterCardToCyberSource(data) {
            this.cardNetworkJourney = "visa_journey";
            this.card_auth_type = "two_d";
            this.handleStepdown();
        },
        getBrowserInfo: function getBrowserInfo() {
            var userAgent = navigator.userAgent;
            var platform = navigator.platform;

            var browser = "Unknown";

            if (userAgent.includes("Chrome") && !userAgent.includes("Edg") && !userAgent.includes("OPR")) {
                browser = "Chrome";
            } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
                browser = "Safari";
            } else if (userAgent.includes("Firefox")) {
                browser = "Firefox";
            } else if (userAgent.includes("Edg")) {
                browser = "Edge";
            } else if (userAgent.includes("OPR") || userAgent.includes("Opera")) {
                browser = "Opera";
            } else if (userAgent.includes("MSIE") || userAgent.includes("Trident")) {
                browser = "Internet Explorer";
            }

            return {
                browser: browser,
                userAgent: userAgent,
                platform: platform
            };
        },
        getCardBrand: function getCardBrand(cardNumber) {
            var cleaned = cardNumber.replace(/\D/g, "");

            if (/^4/.test(cleaned)) return "visa";
            if (/^5[1-5]/.test(cleaned)) return "mastercard";
            if (/^2(?:2(?:2[1-9]|[3-9][0-9])|[3-6][0-9][0-9]|7(?:[0-1][0-9]|20))/.test(cleaned)) return "mastercard";
            if (/^3[47]/.test(cleaned)) return "amex";
            if (/^6(?:011|5)/.test(cleaned)) return "discover";
            if (/^3(?:0[0-5]|[68])/.test(cleaned)) return "dinersclub";
            if (/^35(2[89]|[3-8][0-9])/.test(cleaned)) return "jcb";
            if (/^(?:2131|1800)/.test(cleaned)) return "jcb";
            if (/^62/.test(cleaned)) return "unionpay";
            if (/^(?:508[5-9]|6070|607[1-8]|6521[5-9]|652[2-9]|6530|6531)/.test(cleaned)) return "rupay";
            if (/^220[0-4]/.test(cleaned)) return "mir";
            if (/^(?:5[06789]|6)/.test(cleaned)) return "maestro";

            return "unknown";
        },
        getCardType: function getCardType(card_brand) {
            if (card_brand == "visa") return "001";
            if (card_brand == "mastercard") return "002";
            if (card_brand == "amex") return "003";
            if (card_brand == "dankort") return "034";
            if (card_brand == "hipercard") return "050";
            if (card_brand == "dinersclub") return "005";
            if (card_brand == "discover") return "004";
            if (card_brand == "jcb") return "007";
            if (card_brand == "maestro") return "042";
            if (card_brand == "unionpay") return "062";
            if (card_brand == "visaelectron") return "001";
            if (card_brand == "elo") return "054";
            if (card_brand == "aura") return "051";
            if (card_brand == "uatp") return "040";
            if (card_brand == "unknown") return "040";
        },
        handleProceed: function handleProceed() {
            this.step = this.NextStep();
        },
        handleTryDifferentCard: function handleTryDifferentCard() {
            this.cardErrors = [];
            this.showCardErrors = false;

            this.card_auth_type = null;
            this.selectedCard = {};
            this.getAndCheckSavedCards();
        },
        saveInLocalStorage: function saveInLocalStorage(data) {
            if (!data.saveCardProfile) return;

            var fingerprint = data.deviceFingerPrint;
            var cardProfileId = data.cardProfileID;

            var existing = localStorage.getItem('profiles');
            var cardProfiles = existing ? JSON.parse(existing) : { uuids: [], fingerprint: fingerprint };

            if (!cardProfiles.uuids.includes(cardProfileId)) {
                cardProfiles.uuids.push(cardProfileId);
            }

            localStorage.setItem('profiles', (0, _stringify2.default)(cardProfiles));
        },
        getAndCheckSavedCards: async function getAndCheckSavedCards() {
            var existing = localStorage.getItem('profiles');
            if (existing) {
                var data = JSON.parse(existing);

                try {
                    var response = await Vue.axios.post(this.base_url + this.activeGateway.configs.cs_profiles_url, data, this.getAuthHeaders());

                    var cards = response.data;

                    if (Array.isArray(cards) && cards.length > 0) {
                        this.savedCards = cards;
                        this.step = "showSavedCards";
                    } else {
                        this.savedCards = [];
                        this.step = 1;
                    }
                } catch (error) {
                    this.savedCards = [];
                }
            } else {
                this.step = 1;
            }
        },
        NextStep: function NextStep() {
            return ++this.step;
        },
        PrevStep: function PrevStep() {
            return --this.step;
        }
    },
    computed: {
        activeGateway: function activeGateway() {
            var isTwoD = this.card_auth_type === "two_d";
            var isMastercardJourney = this.cardNetworkJourney === "mastercard_journey";
            if (isMastercardJourney) {
                return (0, _assign2.default)({}, isTwoD ? this.masterCardTwoDcard : this.masterCardGateway);
            }

            return (0, _assign2.default)({}, isTwoD ? this.twoDcard : this.gateway);
        },

        amountToCharge: function amountToCharge() {
            var amount = void 0;
            if (this.card_auth_type === 'two_d') {
                amount = parseFloat(this.twoDcard.configs.card_charges) + parseFloat(this.amount_due);
            } else {
                amount = parseFloat(this.gateway.configs.card_charges) + parseFloat(this.amount_due);
            }

            return Math.ceil(amount * 100) / 100;
        }

    }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-1 flex flex-col gap-6 justify-between h-full overflow-hidden"},[_c('Transition',{attrs:{"name":"fade-slide","mode":"out-in"}},[_c('div',{key:_vm.step},[(_vm.step === 'showSavedCards')?_c('SavedCardProfiles',{attrs:{"savedCards":_vm.savedCards},on:{"cardSelected":_vm.doHandleCardSelection,"addPaymentMethod":_vm.handleAddPaymentMethod,"removeCard":_vm.handleRemoveCard}}):_vm._e(),_vm._v(" "),(_vm.showCardErrors)?_c('CardErrors',{attrs:{"errors":_vm.cardErrors},on:{"tryAnotherCard":_vm.handleTryDifferentCard}}):_vm._e(),_vm._v(" "),(_vm.step === 1)?_c('collect-card-details',{attrs:{"selectedCard":_vm.selectedCard},on:{"collectedCardDetails":_vm.handleFormParams,"cancel":_vm.handleCancel}}):_vm._e(),_vm._v(" "),(_vm.step === 2 || _vm.step == 'DeviceDataCollection')?_c('VerifyTransactions'):_vm._e(),_vm._v(" "),(_vm.step == 'DeviceDataCollection')?_c('CardinalCollection',{attrs:{"url":_vm.deviceDataCollectionUrl,"token":_vm.accessToken,"origin":_vm.origin},on:{"enrollmentChecked":_vm.handleEnrollment}}):_vm._e(),_vm._v(" "),(_vm.card_auth_type == 'two_d' && _vm.cardNetworkJourney =='visa_journey')?_c('TwoDCard',{attrs:{"pendingVerification":_vm.pendingVerification,"gateway":_vm.gateway,"amount":_vm.amountToCharge,"currency":_vm.currency,"invoice_no":_vm.invoice_no,"base_url":_vm.base_url,"decision":_vm.decision,"card_profile_id":_vm.card_profile_id,"callback_url":_vm.callback_url,"wallet_token":_vm.wallet_token},on:{"tryAnotherCard":_vm.handleTryDifferentCard,"addError":_vm.handleAddError,"revokePendingVerification":_vm.handleRevokePendingVerification}}):_vm._e(),_vm._v(" "),(_vm.card_auth_type == 'three_d' && _vm.cardNetworkJourney =='visa_journey')?_c('ThreeDs',{attrs:{"token":_vm.pareqToken,"stepupURL":_vm.stepupURL,"md":_vm.trx_details,"invoice":_vm.invoice,"callback_url":_vm.callback_url,"origin":_vm.origin},on:{"stepupChecked":_vm.handleStepup,"stepDown":_vm.handleStepdown,"tryDifferentCard":_vm.handleTryAnotherWay}}):_vm._e(),_vm._v(" "),(_vm.cardNetworkJourney == 'mastercard_journey')?_c('MasterCard',{attrs:{"activeGateway":_vm.activeGateway,"currency":_vm.currency,"formParams":_vm.formParams,"base_url":_vm.base_url,"invoice_no":_vm.invoice_no,"walletToken":_vm.wallet_token,"invoice":_vm.invoice,"card_profile_id":_vm.card_profile_id,"callback_url":_vm.callback_url},on:{"routeMasterCardToCyberSource":_vm.routeMasterCardToCyberSource}}):_vm._e()],1)])],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e23e9ad6", __vue__options__)
  } else {
    hotAPI.reload("data-v-e23e9ad6", __vue__options__)
  }
})()}